(function () {
    'use strict';
    var m = angular.module('app');
    m.service('licensesManager', ["$q", "http", "licensesDao", function ($q, http, licensesDao) {
        var initialized = false;
        var licenses = {};
        var licenseAvailability = false;
        function reloadLicenses() {
            return licensesDao.getLicenses().then(function (response) {
                _(response.data.data).each(function (data) {
                    if (data.saas && data.seats && !_(data.seats).isObject()) {
                        licenseAvailability = true;
                        licenses[data.saas] = data.seats;
                    }
                });
                initialized = true;
                return $q.when({});
            });
        }
        var licensesManager = {
            init: function () {
                if (initialized) {
                    return $q.when();
                }
                return reloadLicenses();
            },
            reloadLicenses: reloadLicenses,
            getLicensesBySaas: function (saas) {
                return licenses[saas];
            },
            licenseAvailability: function () {
                return licenseAvailability;
            }
        };
        return licensesManager;
    }]);
}());